import { createRoot } from 'react-dom/client'
import App from './core/App'
import './index.css'

createRoot(document.getElementById("root")!).render(<App />);
